export class ListAzureKeyVaultKeysRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureKeyVaultKeysRequest.attributeTypeMap;
    }
    constructor() {
    }
}
